import React, { useContext, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import FlagIcon from '../../../Icons/FlagIcon/FlagIcon';
import SuccessPopup from '../../../Elements/PopUp/SuccessPopup/SuccessPopup';
import {
    PageContext,
    CommunityContext,
} from '../../../../contexts/ContextCreator';

import './ModerationFlag.scss';

const ModerationFlag = ({ hash }) => {
    const { vote, getContent } = useContext(CommunityContext);
    const { wrapAuth, isLoggedIn } = useContext(PageContext);
    const [showFlagMenu, setShowFlagMenu] = useState(false);
    const [isFlagged, setIsFlagged] = useState(false);

    const content = getContent(hash);

    const flagContent = useCallback(() => {
        vote(hash, 'flag');
        setShowFlagMenu(false);
    }, [hash, vote, setShowFlagMenu]);

    const closePopup = useCallback(() => {
        setShowFlagMenu(false);
    }, [setShowFlagMenu]);

    const handleFlagClick = useCallback(() => {
        if (!isLoggedIn()) return;
        if (isFlagged) {
            vote(hash, 'flag');
            return;
        }
        setShowFlagMenu(true);
    }, [hash, isFlagged, isLoggedIn, vote]);

    useEffect(() => {
        setIsFlagged(content.userFlagged);
    }, [setIsFlagged, content.userFlagged]);

    const label = isFlagged ? 'Flagged' : 'Flag';

    const authMetrics = {
        login_trigger: 'moderation-menu-flag',
        community_content_key: `${content.type}-${hash}`,
        community_on_comment: content.type === 'community-comment',
    };

    return wrapAuth(
        `moderation-menu-flag-${hash}`,
        <>
            <div
                className="component-ModerationFlag"
                onClick={handleFlagClick}
                onKeyPress={handleFlagClick}
                role="button"
                tabIndex={0}
            >
                <FlagIcon isActive={isFlagged} />
                <span className="moderationFlag-label">{label}</span>
            </div>
            <div>
                {showFlagMenu && (
                    <SuccessPopup
                        title="Flag this item"
                        buttonOnClick={flagContent}
                        buttonText="Yes, please."
                        cancelButtonOnClick={closePopup}
                        secondaryText="Would you like to submit this item for review by our Community Manager?"
                        showLogo={false}
                        className="moderation-flag-style"
                    />
                )}
            </div>
        </>,
        authMetrics
    );
};

ModerationFlag.propTypes = {
    hash: PropTypes.string.isRequired,
};
ModerationFlag.defaultProps = {};

ModerationFlag.displayName = 'ModerationFlag';

export default ModerationFlag;
